import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { SEOHead } from '@/components/SEOHead';

export function ThankYou() {
  return (
    <div className="bg-zinc-950 min-h-screen flex items-center">
      <SEOHead />
      <div className="container-site py-32 max-w-2xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-500/10 border border-amber-500/20 mb-8">
          <CheckCircle size={24} className="text-amber-500" />
        </div>
        <span className="text-xs font-mono tracking-widest uppercase text-amber-500 block mb-5">
          Submission Received
        </span>
        <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-zinc-100 mb-6">
          Protocol Initiated.
        </h1>
        <p className="text-base text-zinc-400 leading-relaxed mb-4">
          Your intake submission has been received. We will review your organizational context and
          data readiness parameters and respond within 1–2 business days.
        </p>
        <p className="text-sm text-zinc-500 leading-relaxed mb-10">
          If your submission included urgent timeline requirements, those will be factored into our response.
          No data has been transferred at this stage. Data submission occurs only after engagement confirmation.
        </p>
        <div className="border border-zinc-800 rounded-md p-6 bg-zinc-900/20 text-left mb-10">
          <h3 className="text-sm font-medium text-zinc-300 mb-3">What happens next</h3>
          <ul className="space-y-2">
            {[
              'We review your intake submission (1–2 business days)',
              'We send an engagement confirmation with data submission instructions',
              'You submit your interval-level export via secure file transfer',
              'Classification begins on confirmed receipt (3 weeks)',
              'Deliverable delivered via secure link',
            ].map((step, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="text-xs font-mono text-amber-500/70 mt-0.5 flex-shrink-0">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-sm text-zinc-400">{step}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            data-testid="thankyou-home-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-zinc-100 text-zinc-900 rounded-md text-sm font-medium hover:bg-white transition-colors duration-200"
          >
            Return Home <ArrowRight size={14} />
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-zinc-700 text-zinc-300 rounded-md text-sm hover:border-zinc-500 hover:text-white transition-colors duration-200"
          >
            Review FAQ
          </Link>
        </div>
      </div>
    </div>
  );
}
